import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import {
  MonetizationState,
  SendRequestAction,
  SetMonetizationLoadedAction,
  SetShareUrlAction,
  SetSumsubTokenAction,
  SetVerificationStatusAction
} from '$store/monetization/interface';

const initialState: MonetizationState = {
  isLoading: true,
  isFailed: false,
  status: 'not_verified',
  sumsubToken: '',
  shareUrl: '',
};

export const { actions, reducer } = createSlice({
  name: 'invite',
  initialState,
  reducers: {
    loadMonetization(state) {
      state.isLoading = true;
      state.isFailed = false;
    },
    setMonetizationLoaded(state, action: SetMonetizationLoadedAction) {
      const { status } = action.payload;

      state.isLoading = false;
      state.status = status;
    },
    setMonetizationFailed(state) {
      state.isLoading = false;
      state.isFailed = true;
    },
    sendRequest(_, __: SendRequestAction) {},
    setMonetizationStatus(state, action: SetVerificationStatusAction) {
      state.status = action.payload;
    },
    startKYC() {},
    setSumsubToken(state, action: SetSumsubTokenAction) {
      state.sumsubToken = action.payload;
    },
    setShareUrl(state, action: SetShareUrlAction) {
      state.shareUrl = action.payload || '';
    },
    generateLink() {},
  },
});

export { reducer as monetizationReducer, actions as monetizationActions };

export const monetizationSelector = (state: RootState) => state.monetization;
